import axios from 'axios';
import router from '@/router/index';

const API_BASE_URL = 'https://zapiola-grow-api.vercel.app/api';
const CACHE_VERSION = '1.0'; // Agregar versión de caché

// Limpiar caché antiguo si es necesario
const initializeCache = () => {
    const storedVersion = localStorage.getItem('cacheVersion');
    if (storedVersion !== CACHE_VERSION) {
        console.log('Nueva versión de caché detectada, limpiando caché antiguo...');
        // Agregar limpieza de caché de actividades
        Object.keys(localStorage).forEach(key => {
            if (key.startsWith('activities_') || key === 'activity_stats') {
                localStorage.removeItem(key);
                localStorage.removeItem(`${key}_timestamp`);
            }
        });
        // Limpiar todo el caché relacionado
        localStorage.removeItem('accessToken');
        localStorage.removeItem('products');
        localStorage.removeItem('productsTimestamp');
        localStorage.removeItem('userOrders');
        localStorage.removeItem('adminOrders');
        localStorage.removeItem('ordersTimestamp');
        // Establecer nueva versión
        localStorage.setItem('cacheVersion', CACHE_VERSION);
    }
};

// Ejecutar limpieza al iniciar
initializeCache();

const apiClient = axios.create({
    baseURL: API_BASE_URL,
    timeout: 30000, // Increased timeout to 30 seconds
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
    }
});

// Add request interceptor for debugging
apiClient.interceptors.request.use(request => {
  console.log('Starting Request:', {
    url: request.url,
    method: request.method,
    headers: request.headers,
    data: request.data
  });
  return request;
});

// Interceptor para agregar el token a todas las peticiones
apiClient.interceptors.request.use(
    config => {
        const token = localStorage.getItem('accessToken');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

// Add response interceptor for debugging
apiClient.interceptors.response.use(
  response => {
    console.log('Response:', {
      url: response.config.url,
      status: response.status,
      data: response.data
    });
    return response;
  },
  error => {
    console.error('API Error:', {
      url: error.config?.url,
      status: error.response?.status,
      data: error.response?.data,
      message: error.message
    });
    return Promise.reject(error);
  }
);

apiClient.interceptors.response.use(
    response => response,
    error => {
        // Handle connection abort errors more gracefully
        if (error.code === 'ECONNABORTED') {
            console.warn('Request timeout - the server took too long to respond');
            return Promise.reject({
                message: 'La solicitud tardó demasiado tiempo. Por favor, inténtalo nuevamente.',
                originalError: error
            });
        }

        // Handle network errors
        if (error.message === 'Network Error') {
            console.warn('Network error - unable to connect to the server');
            return Promise.reject({
                message: 'No se pudo conectar con el servidor. Por favor, verifica tu conexión a internet.',
                originalError: error
            });
        }

        // Handle authentication errors
        if (error.response && error.response.status === 401) {
            localStorage.removeItem('accessToken');
            router.push({ name: 'Login' });
        }
        return Promise.reject(error);
    }
);

export default apiClient;